/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Reducer for SettingsLabels component
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.3.0
 */

import produce from 'immer';

import { ILabel } from '../../../../components/Table/components/TableColumns/TableLabelBlock/TableLabelBlock';
import {
    GET_SETTINGS_LABELS_LIST_ACTION,
    GET_SETTINGS_LABELS_LIST_FAILURE,
    GET_SETTINGS_LABELS_LIST_SUCCESS,
    REMOVE_SETTINGS_LABEL_SUCCESS,
} from './settingsLabelsConstants';
import { TSettingsLabelsActionTypes } from './settingsLabelsTypes';

export interface ISettingsLabelsState {
    error: string;
    isLoading: boolean;
    isLoaded: boolean;
    list: ILabel[];
    hasMore: boolean;
    search: string;
}

export const initialSettingsLabelsState: ISettingsLabelsState = {
    error: '',
    isLoaded: true,
    isLoading: false,
    list: [],
    hasMore: true,
    search: '',
};

export const settingsLabelsReducer = (state = initialSettingsLabelsState, action: TSettingsLabelsActionTypes) =>
    produce(state, draft => {
        switch (action.type) {
            case GET_SETTINGS_LABELS_LIST_ACTION:
                draft.isLoading = true;
                if (action.payload.search) {
                    draft.search = action.payload.search;
                }
                if (action.payload.start) {
                    draft.list = [];
                }
                break;
            case GET_SETTINGS_LABELS_LIST_SUCCESS:
                draft.isLoaded = true;
                draft.isLoading = false;
                draft.list = action.payload.labelsList;
                draft.hasMore = action.payload.hasMore;
                break;
            case GET_SETTINGS_LABELS_LIST_FAILURE:
                draft.isLoaded = true;
                draft.isLoading = false;
                draft.error = action.payload;
                break;
            case REMOVE_SETTINGS_LABEL_SUCCESS:
                draft.list = draft.list.filter(row => row.id !== action.payload.labelId);
                break;
            default:
                break;
        }
    });
